import { render, staticRenderFns } from "./plate.vue?vue&type=template&id=04d3e736&scoped=true"
import script from "./plate.vue?vue&type=script&lang=js"
export * from "./plate.vue?vue&type=script&lang=js"
import style0 from "./plate.vue?vue&type=style&index=0&id=04d3e736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3e736",
  null
  
)

export default component.exports